var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticClass:"table"},[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('Nova vrednost')))]),_c('td',[_c('RenderValue',{attrs:{"value":_vm.changes.new}})],1)]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('Stara vrednost')))]),_c('td',[_c('RenderValue',{attrs:{"value":_vm.changes.old}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }